import type { TaskTemplateCategory } from "./types";

export const MSP_ONBOARDING_TEMPLATES: TaskTemplateCategory = {
  id: "onboarding",
  name: "Client Onboarding",
  description: "Templates for onboarding new clients",
  templates: [
    {
      id: "onboard-new-client",
      name: "Onboard New Client",
      description: "Complete onboarding process for a new client",
      title: "Onboard New Client: [Client Name]",
      description_text: `Complete onboarding process for new client including:

1. Initial setup and configuration
2. Account creation and access setup
3. Documentation review and signing
4. System access and training
5. First service delivery

**Client Information:**
- Company: [Client Name]
- Contact: [Primary Contact]
- Start Date: [Date]
- Services: [List services]`,
      tags: ["onboarding", "new-client", "setup", "documentation"],
      priority: "high",
      status: "pending",
      category: "onboarding",
    },
    {
      id: "setup-client-monitoring",
      name: "Setup Client Monitoring",
      description: "Configure monitoring and alerting for new client",
      title: "Setup Monitoring: [Client Name]",
      description_text: `Configure comprehensive monitoring for client infrastructure:

**Systems to Monitor:**
- [ ] Network devices
- [ ] Servers and workstations
- [ ] Email systems
- [ ] Backup systems
- [ ] Security tools

**Monitoring Tools:**
- RMM agent installation
- Alert configuration
- Dashboard setup
- Notification setup`,
      tags: ["monitoring", "setup", "infrastructure", "alerts"],
      priority: "high",
      status: "pending",
      category: "onboarding",
    },
  ],
};
